import { Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import {
  CardComponent,
  MoneyBag,
  NoDataVisual,
  ProgressBarWithLabels,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import React, { useEffect, useState } from 'react';
import { commasForNumbers } from '../core-utils/helper-utils/helper';
import Employee from '@HomaHealth/ui-component-library/lib/_AIQ-components/atoms/Icons/Employee';

const useStyles = makeStyles()({
  titleGrid: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
  },
  loader: {
    display: 'flex',
    justifyContent: 'center',
    height: '270px',
  },
  body: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    paddingTop: '16px',
  },
});

export interface TopChronicDiseasesProps {
  incurredStartDate?: string;
  incurredEndDate?: string;
  paidStartDate?: string;
  paidEndDate?: string;
  maxClaimDate?: string;
  type: 'cost' | 'member';
  aggregationParameter?: string;
  data?: any;
}

const TopChronicDiseases: React.FC<TopChronicDiseasesProps> = ({
  data,
  type,
}) => {
  const { classes } = useStyles();

  const [topChronicDiseases, setTopChronicDiseases] = useState<any[]>([]);

  //useEffects
  useEffect(() => {
    const topDiagnosis = data?.topDiagnosis.map((item: any) => {
      return {
        value: item?.chronicDiseasePercent,
        title: item?.chronicDiseaseName,
        displayValue:
          type === 'cost'
            ? '$' + commasForNumbers(item?.totalPaidofChronicDisease, 0)
            : item?.chronicDiseasePercent?.toFixed(0) + '%',
      };
    });
    setTopChronicDiseases(topDiagnosis);
  }, []);

  return (
    <CardComponent
      title={
        <Grid className={classes.titleGrid}>
          {type === 'cost' ? (
            <MoneyBag width="35px" height="37px" />
          ) : (
            <Employee width="35px" height="36px" />
          )}
          <Typography
            fontSize="14px"
            fontType="semiBold"
            lineHeight="24px"
            textColor={patientAccessTheme.palette.text.highemphasis}
          >
            {`Top 5 Chronic Diseases by
            ${type === 'cost' ? 'Plan Spend' : 'Prevalence'}`}
          </Typography>
        </Grid>
      }
      height="290px"
      width="380px"
      padding="16px"
      body={
        <>
          {topChronicDiseases?.length > 0 ? (
            <Grid className={classes.body}>
              {topChronicDiseases?.map((item: any) => (
                <ProgressBarWithLabels
                  title={item?.title}
                  value={item?.value}
                  displayValue={item?.displayValue}
                  barWidth="250px"
                  barHeight="6px"
                  titleTypographyStyles={{
                    fontSize: '14px',
                    fontType: 'medium',
                    lineHeight: '20px',
                  }}
                  valueTypographyStyles={{
                    fontSize: '14px',
                    fontType: 'medium',
                    lineHeight: '20px',
                    textColor: patientAccessTheme.palette.text.mediumemphasis,
                  }}
                />
              ))}
            </Grid>
          ) : (
            <NoDataVisual
              width="100%"
              height="270px"
              content="No Data Available"
            />
          )}
        </>
      }
    />
  );
};

export default TopChronicDiseases;
